'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { setDayjsLocale } from '@/lib/dayjs';

export function DayjsLocaleProvider() {
  const locale = useLocale();

  useEffect(() => {
    const dayjsLocale = (locale === 'kk' ? 'kz' : (locale === 'ru' || locale === 'en' ? locale : 'en')) as
      | 'kz'
      | 'ru'
      | 'en';

    setDayjsLocale(dayjsLocale);
  }, [locale]);

  return null;
}
